import {
    AssortmentTaskType,
    SubtaskAssortmentMatrix,
    SubtaskAssortmentMatrixPayload,
    SubtaskFacingsPayload,
    SubtaskFinGroupPhotosPayload,
    SubtaskProductsMatrixPayload,
    TaskStatus,
} from "tm-shared/types";

interface GetNextSubtaskIdArgs {
    subtasks: SubtaskAssortmentMatrix[];
    currentSubtaskId: string;
}

export const getNextSubtaskId = ({
    subtasks,
    currentSubtaskId,
}: GetNextSubtaskIdArgs) => {
    const subtaskIds = subtasks.map((t) => t.subtaskId);
    const activeIndex = subtaskIds.indexOf(currentSubtaskId);

    if (activeIndex === -1) {
        return {
            isLast: false,
            nextSubtaskId: null,
        };
    }

    const isLast = activeIndex === subtaskIds.length - 1;

    return {
        isLast,
        nextSubtaskId: isLast ? null : subtaskIds[activeIndex + 1] ?? null,
    };
};

interface MakeForceStepCompletePayloadArgs {
    subtask: SubtaskAssortmentMatrix;
    comment: string;
}

export const makeForceStepCompletePayload = ({
    subtask,
    comment,
}: MakeForceStepCompletePayloadArgs): SubtaskAssortmentMatrixPayload | null => {
    const { subtaskId, contractId } = subtask;

    if (subtask.type === AssortmentTaskType.ProductsMatrix) {
        const {
            context: { products },
        } = subtask;

        const productsMatrixPayload: SubtaskProductsMatrixPayload = {
            type: AssortmentTaskType.ProductsMatrix,
            subtaskId,
            contractId,
            completed: true,
            products: {},
        };

        products.forEach((barcode) => {
            productsMatrixPayload.products[barcode] = {
                comment,
                status: TaskStatus.Rejected,
            };
        });

        return productsMatrixPayload;
    }

    if (subtask.type === AssortmentTaskType.FinGroupPhotos) {
        const {
            context: { photos },
        } = subtask;

        const finGroupPhotosPayload: SubtaskFinGroupPhotosPayload = {
            type: AssortmentTaskType.FinGroupPhotos,
            subtaskId,
            contractId,
            completed: true,
            tasks: {},
        };

        photos.forEach((finGroup) => {
            finGroupPhotosPayload.tasks[finGroup] = {
                id: finGroup,
                comment,
                status: TaskStatus.Rejected,
                photos: [],
            };
        });

        return finGroupPhotosPayload;
    }

    if (subtask.type === AssortmentTaskType.Facings) {
        const {
            context: { facings },
        } = subtask;

        const facingsPayload: SubtaskFacingsPayload = {
            type: AssortmentTaskType.Facings,
            subtaskId,
            contractId,
            completed: true,
            facings: {},
        };

        facings.forEach(({ finGroup }) => {
            facingsPayload.facings[finGroup] = {
                comment,
                amount: 0,
            };
        });

        return facingsPayload;
    }

    return null;
};
